import messageListCommon from "@/views/messageCommon/MessageListCommon";

export default {
    name: "localLogListPage",
    components: {messageListCommon},
}